<template>
  <div class="page-content">
    <div class="payment">
      <div class="card">
        <div class="payment-success">
          <CustomIcon :name="content.image" />
          <h3>{{ content.title }}</h3>
          <p class="payment-success-text">{{ content.description }}</p>
          <CustomButton variation="primary" :onClick="action"
            >Continue</CustomButton
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CustomIcon from "@/components/CustomIcon.vue";
import CustomButton from "@/components/CustomButton.vue";
export default {
  props: {
    content: {
      title: String,
      description: String,
      image: String,
    },
    action: {
      type: Function,
      default() {
        return null;
      },
    },
  },
  components: { CustomIcon, CustomButton },
};
</script>
